import { useEffect, useState } from "react";
import Navbar from "../../Components/NavBar/Navbar"
import { Link } from 'react-router'
import { getPagos } from "../../Fetch/GetPagos";
import { useNavigate } from "react-router"
import Tabla, { Cell, Row, Head, Body } from "../../Components/Tabla/Tabla";
import Loading from "../../Components/Loading/Loading";
import './css/pagos.css'
import './css/pagos-phone.css'

export default function Pagos() {
    let navigate = useNavigate();
    const [Comp, setComp] = useState({ Pay: [], Loading: true })

    useEffect(() => {
        document.title = 'Pagos';
        getPagos().then(res => {
            if (res.valid) {
                setComp(v => ({
                    ...v,
                    Loading: false,
                    Pay: res.data.payload.map((pay) => ({
                        ...v.Pay,
                        idPay: pay.idMovimiento_Bancario,
                        idPayhash: pay.IdMovhash,
                        Fecha: pay.Fecha,
                        Monto: pay.Monto,
                        Nota: pay.Notas
                    }))
                }))
            } else {
                localStorage.removeItem("ContaKMPCot")
                navigate("/")
            }

        })

    }, [navigate])

    return (
        <Navbar
            menu={[
                { txt: "Cotizaciones", link: "/FindCotizacion" }
            ]}>

            {Comp.Loading === false ?
                <Tabla className='PagosUser'>
                    <Head>
                        <Row className='Flags'>
                            <Cell>Pago</Cell>
                            <Cell>Fecha</Cell>
                            <Cell>Monto</Cell>
                            <Cell>Descripción</Cell>
                        </Row>
                    </Head>
                    <Body>
                        {

                            Comp.Pay.length > 0 ?
                                Comp.Pay.map((Pa, iPa) =>
                                (

                                    <Row key={iPa}>
                                        <Cell>PA-{Pa.idPay}</Cell>
                                        <Cell>{Pa.Fecha}</Cell>
                                        <Cell><Link to={`/Pago?hash=${Pa.idPayhash}&pay=${Pa.idPay}`} target="_blank" params={{ fromFeed: true }}>
                                            $ {new Intl.NumberFormat('en-US').format(Pa.Monto)}
                                        </Link></Cell>
                                        <Cell>{Pa.Nota}</Cell>
                                    </Row>
                                )) :
                                <Row>
                                    <Cell colSpan={4} style={{ width: '100%' }}>
                                        No existen Pagos
                                    </Cell>
                                </Row>

                        }
                    </Body>
                </Tabla> :
              
                        <Loading style={{ top: '80px' }} />
                   
            }
        </Navbar>
    )
}
